import BadgeIcon from "../../../Icons/BadgeIcon";
import { useParams } from "react-router-dom";
function ShFacebook({ entrytype,entryjson, saveMemberEntry,contest_id,purl,ffrefurl,contestDetails }) {
    //const { showToast } = useToast();
    const entrydet = JSON.parse(entryjson.entry);
    const session_member = sessionStorage.getItem("member_" + contest_id);
    const { cid } = useParams();
     let member_det = JSON.parse(session_member);
     let vshare_url;
    if (ffrefurl !== "" && ffrefurl !== null && typeof ffrefurl !== "undefined") {
        vshare_url = ffrefurl + "?mid=" + member_det?.url_token;
    } else if (
        contestDetails.published_url !== "" &&
        contestDetails.published_url !== "" &&
        contestDetails.published_url !== null &&
        typeof contestDetails.published_url !== "undefined"
    ) {
        vshare_url =
        contestDetails?.published_url + "?mid=" + member_det?.url_token;
    } else if (purl !== "" && purl !== null && typeof purl !== "undefined") {
        vshare_url = purl + "?mid=" + member_det?.url_token;
    } else {
        //vshare_url = config.VIRAL_SHARE_URL + "/" + contest_id + "/" + member_det?.url_token;
        // vshare_url = `${window.location.origin}/${contest_id}?mid=${member_det?.url_token}`;

        if(cid == null){
            vshare_url = `${window.location.origin}?mid=${member_det?.url_token}`;
        }else{
            vshare_url = `${window.location.origin}/${contest_id}?mid=${member_det?.url_token}`;
        }
    }

    


   const saveEntry = () => {
        let content = encodeURIComponent(entrydet.content);
        let vshare_url_en = encodeURIComponent(vshare_url);
        //console.log(entrydet.content);
        let fburl;
        if(entrytype === 'shfacebook'){
            fburl = `https://www.facebook.com/sharer/sharer.php?u=${vshare_url_en}&quote=${content}`;
        }else if(entrytype === 'shx'){
            fburl = `https://twitter.com/intent/tweet?text=${content}&url=${vshare_url_en}`;
        }else {
            fburl =  `https://wa.me/?text=${content}%20${vshare_url_en}`;
        }

        
        console.log(fburl);

        window.open(fburl, '_blank'); // open Facebook share dialog

       saveMemberEntry();
   }

    return (
        <div>

            <div className="flex flex-col md:flex-row justify-between">
                <div className="md:w-[440px]">
                    <h4 className="font-medium text-[15px] leading-[22px] text-black opacity-100 mb-1" >{entryjson?.headline}</h4>
                    <p className="text-left font-normal text-[14px] leading-[20px] text-black opacity-100 sm:text-[12px] sm:leading-[20px] mb-1">{entrydet?.description}</p>
                </div>
                <div className="hidden min-[426px]:block">
                    <span class="earn_points_btn bg-white text-[#0274F7] text-sm font-medium inline-flex items-center px-3 py-1 rounded-md border border-[#0274F7]">
                        <BadgeIcon width={20} height={20} className={"mr-1"} />
                        {entrydet?.worth} <span className="text-sm ml-1">Points</span>
                    </span>
                </div>
            </div>
            <div className="flex items-center justify-between">
                <div className="">
                    <button onClick={() => saveEntry()} className={`primary_btn_bg bg-[#0274F7] text-white px-3 py-2 rounded-md text-[13px] leading-[15px] text-left border border-[#0274F7]  hover:bg-white hover:text-[#0274F7] hover:border-[#0274F7]`}>{entrydet?.btn_text}</button>
                </div>
                <div className="">
                    <span class="earn_points_btn bg-white ml-2 text-[#0274F7] text-sm font-medium inline-flex items-center px-3 max-[325px]:px-0 py-1 rounded-md border border-[#0274F7] sm:hidden">
                        <BadgeIcon width={20} height={20} className={"mr-1"} />
                        {entrydet?.worth} <span className="text-sm ml-1">Points</span>
                    </span>
                </div>
            </div>
        </div>
    );
}

export default ShFacebook;